import Cookies from 'js-cookie'
import { isLocal } from './index'

export function getCurrency() {
  return Cookies.get('currency')
}

export function setCurrency(value = 'usd') {
  Cookies.set('currency', value, { sameSite: 'none', secure: true })
}

export function setLanguage(value = 'en') {
  Cookies.set('language', value, {
    sameSite: 'none',
    secure: true,
    domain: isLocal() ? undefined : '.logo.com',
  })
}

export function getLanguage() {
  return Cookies.get('language', {
    domain: isLocal() ? undefined : '.logo.com',
  })
}

export function getCountry() {
  return Cookies.get('country')
}

export function setCountry(value = 'US') {
  Cookies.set('country', value, { sameSite: 'none', secure: true })
}
